import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import {
  AssignApartmentToAgencyCommand,
  EndAgencyApartmentAssignmentCommand,
  FilterAgencyApartmentAssignmentsCommand,
  GetAgencyApartmentAssignmentByIdCommand,
} from './agency-apartment-assignment.commands';
import {
  CreatedAgencyApartmentAssignmentEvent,
  UpdatedAgencyApartmentAssignmentEvent,
  FilteredAgencyApartmentAssignmentsEvent,
  GottenAgencyApartmentAssignmentEvent,
} from './agency-apartment-assignment.events';
import { isCode } from '../../../shared/helpers/transaction.helpers';

@Injectable()
export class AgencyApartmentAssignmentEffects {
  prefix = 'agency-apartment-assignment';

  assignApartmentToAgencyCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAgencyApartmentAssignmentByIdCommand: Observable<Action<string>> & CreateEffectMetadata;
  endAgencyApartmentAssignmentCommand: Observable<Action<string>> & CreateEffectMetadata;
  filterAgencyApartmentAssignmentsCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.getAgencyApartmentAssignmentByIdCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: GetAgencyApartmentAssignmentByIdCommand,
      prefix: this.prefix,
      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, GottenAgencyApartmentAssignmentEvent)) {
          response.push(
            GottenAgencyApartmentAssignmentEvent({
              agencyApartmentAssignment: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
    this.assignApartmentToAgencyCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: AssignApartmentToAgencyCommand,
      prefix: this.prefix,
      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, CreatedAgencyApartmentAssignmentEvent)) {
          response.push(
            CreatedAgencyApartmentAssignmentEvent({
              agencyApartmentAssignment: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
    this.endAgencyApartmentAssignmentCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: EndAgencyApartmentAssignmentCommand,
      prefix: this.prefix,

      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, UpdatedAgencyApartmentAssignmentEvent)) {
          response.push(
            UpdatedAgencyApartmentAssignmentEvent({
              agencyApartmentAssignment: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
    this.filterAgencyApartmentAssignmentsCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: FilterAgencyApartmentAssignmentsCommand,
      prefix: this.prefix,
      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, FilteredAgencyApartmentAssignmentsEvent)) {
          response.push(
            FilteredAgencyApartmentAssignmentsEvent({
              agencyApartmentAssignments: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
  }
}
